import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Typography } from 'seagull';
import { routes } from '~/constants';
import { formatNumericUSDate } from '~/utils';
const ViewInvoice = (param)=>{
    let { relationshipID, date, testId } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        as: Link,
        to: "".concat(routes.billingHub(relationshipID), "?selectedDate=").concat(formatNumericUSDate(date)),
        testId: testId,
        variant: "paragraph1",
        noWrap: true,
        ellipsis: true,
        children: "View Invoice"
    });
};
export default ViewInvoice;
